export default __webpack_public_path__ + "static/media/download_icon.91e27fea.svg";